import { Component, Input, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { S1Table, S1ButtonType, S1UIService } from '@app/s1';
import { ICassa } from '@app/shared/models/cassa';
import { CassaService, IRicercaCassaParams } from '@app/shared/services/cassa.service';
import { CassaComponent } from '../cassa/cassa.component';

@Component({
  selector: 'ser-casse',
  templateUrl: './casse.component.html',
  styleUrl: './casse.component.scss'
})
export class CasseComponent {

  @Input() set idStazione(newValue: string) {
    this._idStazione = newValue;
    if (this._idStazione) {
      this.cassaService.idPath = this._idStazione;
      this.search();
    }
  }

  @ViewChild('cassaModal') cassaModal: CassaComponent;

  @ViewChild('table') table: S1Table<ICassa>;

  s1ButtonType = S1ButtonType

  searchForm: UntypedFormGroup;

  _idStazione: string;

  constructor (
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private cassaService: CassaService,
    private ui: S1UIService) {

    this.searchForm = this.formBuilder.group({
      'codice': [null, null],
      'attiva': [null, null],
      'idStazione': [null, null]
    })

  }

  ngAfterViewInit(): void { 
    this.search();
  }

  search() {

    if (!this.table) {
      return;
    }

    let param: IRicercaCassaParams = {
      page: this.table?.config.pagination.page.page,
      pageSize: +this.table?.config.pagination.page.itemsPerPage,
      sortBy: "descrizione",
      codice: this.searchForm.controls.codice.value,
      idStazione: this._idStazione
    }

    this.cassaService.ricercaCasse(param).subscribe(cassePaginate => {
      this.table.updateData(cassePaginate.elements, cassePaginate.paginationInfo)
    })

  }

  goToNew() {
    this.cassaModal.open(this._idStazione);
  }

  goToDetail(cassa: ICassa = null) {
    this.cassaModal.open(this._idStazione, cassa);
  }

  askDelete(cassa: ICassa) {

    this.ui.showDialogPopup("casse.messages.delete").then(result => {
      if (result.value) {
        this.delete(cassa)
      }
    })

  }

  private delete(cassaToDelete: ICassa) {

    this.cassaService.elimina(cassaToDelete?.id).subscribe(deleted => {

      if (deleted) {
        this.ui.showSuccessToast("casse.messages.deleted")
        this.table?.refreshAfterDelete()
      }

    })

  }

}